export default "__VITE_ASSET__DUG418wf__"